// widgetAccent.js — 상황판 위젯 공통 accent 색상 매핑 (2026-06-07 큰 카드 패턴 통일)
//
// 본인 위젯(MiniRow) + 관리자 위젯(AdminWidgetCard) + 큰 카드(UnifiedCard) 공유.
// 통일된 큰 카드 디자인:
//   - 배경: 흰색 (bg-white dark:bg-pine-900) — accent 무관
//   - 테두리: border + border-{accent}-100 (옅음)
//   - 상단 강조: border-t-[3px] border-t-{accent}-400 (두꺼운 accent)
//   - 아이콘/값 텍스트: accent text-700
//   - hover: brightness-95
//
// (구) ACCENT_BG = bg-{accent}-50 패턴은 mini row 풍이라 사용 안 함. 호환만 유지.
//
// 사용 카테고리: emerald / orange / indigo / amber / blue / pink / violet / sky / rose / slate

// 카드 배경 통일 — 모든 accent 동일 (흰색)
export const CARD_BG = 'bg-white dark:bg-pine-900';

// 큰 카드용: 테두리 (옅음) + 상단 strong accent
export const ACCENT_BORDER = {
  emerald: 'border-emerald-100 dark:border-emerald-900/40',
  orange:  'border-orange-100 dark:border-orange-900/40',
  indigo:  'border-indigo-100 dark:border-indigo-900/40',
  amber:   'border-amber-100 dark:border-amber-900/40',
  blue:    'border-blue-100 dark:border-blue-900/40',
  pink:    'border-pink-100 dark:border-pink-900/40',
  violet:  'border-violet-100 dark:border-violet-900/40',
  sky:     'border-sky-100 dark:border-sky-900/40',
  rose:    'border-rose-100 dark:border-rose-900/40',
  slate:   'border-slate-200 dark:border-slate-700',
};

// (구) ACCENT_BG — accent 배경 (mini row 풍). 신규 코드는 사용 금지.
// 레거시 호환을 위해 유지하지만 UnifiedCard 는 CARD_BG + ACCENT_BORDER 를 쓴다.
export const ACCENT_BG = {
  emerald: 'bg-emerald-50 border-emerald-200 dark:bg-emerald-900/20 dark:border-emerald-800',
  orange:  'bg-orange-50 border-orange-200 dark:bg-orange-900/20 dark:border-orange-800',
  indigo:  'bg-indigo-50 border-indigo-200 dark:bg-indigo-900/20 dark:border-indigo-800',
  amber:   'bg-amber-50 border-amber-200 dark:bg-amber-900/20 dark:border-amber-800',
  blue:    'bg-blue-50 border-blue-200 dark:bg-blue-900/20 dark:border-blue-800',
  pink:    'bg-pink-50 border-pink-200 dark:bg-pink-900/20 dark:border-pink-800',
  violet:  'bg-violet-50 border-violet-200 dark:bg-violet-900/20 dark:border-violet-800',
  sky:     'bg-sky-50 border-sky-200 dark:bg-sky-900/20 dark:border-sky-800',
  rose:    'bg-rose-50 border-rose-200 dark:bg-rose-900/20 dark:border-rose-800',
  slate:   'bg-slate-50 border-slate-200 dark:bg-slate-800/40 dark:border-slate-700',
};

export const ACCENT_TEXT = {
  emerald: 'text-emerald-700 dark:text-emerald-300',
  orange:  'text-orange-700 dark:text-orange-300',
  indigo:  'text-indigo-700 dark:text-indigo-300',
  amber:   'text-amber-700 dark:text-amber-300',
  blue:    'text-blue-700 dark:text-blue-300',
  pink:    'text-pink-700 dark:text-pink-300',
  violet:  'text-violet-700 dark:text-violet-300',
  sky:     'text-sky-700 dark:text-sky-300',
  rose:    'text-rose-700 dark:text-rose-300',
  slate:   'text-slate-700 dark:text-slate-300',
};

// (구) 큰 카드 상단 border-t 색상. UnifiedCard 로 통합되어 현재 호출은 없으나
// 레거시 호환을 위해 유지 (앞으로 다시 사용할 수 있음).
export const ACCENT_BORDER_T = {
  emerald: 'border-t-emerald-400',
  orange:  'border-t-orange-400',
  indigo:  'border-t-indigo-400',
  amber:   'border-t-amber-400',
  blue:    'border-t-blue-400',
  pink:    'border-t-pink-400',
  violet:  'border-t-violet-400',
  sky:     'border-t-sky-400',
  rose:    'border-t-rose-400',
  slate:   'border-t-slate-400',
};

export const DEFAULT_ACCENT = 'slate';

export function accentBg(key) {
  return ACCENT_BG[key] || ACCENT_BG[DEFAULT_ACCENT];
}

export function accentText(key) {
  return ACCENT_TEXT[key] || ACCENT_TEXT[DEFAULT_ACCENT];
}

export function accentBorderT(key) {
  return ACCENT_BORDER_T[key] || ACCENT_BORDER_T[DEFAULT_ACCENT];
}

// 큰 카드 패턴: 테두리 색 (옅은 accent-100)
export function accentBorder(key) {
  return ACCENT_BORDER[key] || ACCENT_BORDER[DEFAULT_ACCENT];
}
